module.exports = __webpack_public_path__ + "static/media/wordmark-color.07302cc3.png";